import { SecondaryButton } from 'components';
import styles from './buttons.module.css';

const RoleChangeButton = (props) => {
	return (
		<div className={styles.childAdminItemWrapper}>
			<div>
				<div className={styles.childAdminBoldLabel}>Change User Role</div>
				<div>Change user based on role selected</div>
			</div>
			<div className={styles.childAdminButtonContainer}>
				<SecondaryButton onClick={props.handleOnClick}>
					Change Role
				</SecondaryButton>
			</div>
		</div>
	);
};

export default RoleChangeButton;
